<template>
  <v-layout justify-space-around wrap>
    <v-flex xs12>
      <div id="mapContainer" class="elevation-5" />
    </v-flex>
    <v-flex xs10 v-if="mapLoaded" />
  </v-layout>
</template>

<script>
  import MomentUtil from './mixins/MomentUtil'
  import StationUtil from './mixins/StationUtil'

  import '../../static/Scripts/leaflet-fullscreen/Control.FullScreen.js'
  import '../../static/Scripts/leaflet-fullscreen/Control.FullScreen.css'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    setTimeout,
    setInterval,
    clearInterval,
  } from 'timers'

  import {
    SOURCE_TYPES,
    SOURCE_TYPES_WITH_NAME_INDEX,
    SOURCE_TYPES_WITH_NAME,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const sampleActivity = createNamespacedHelpers('sampleactivity')
  // const stations = createNamespacedHelpers('stations')
  const app = createNamespacedHelpers('app')
  const authenticate = createNamespacedHelpers('authenticate')
  const map = createNamespacedHelpers('map')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  function groupBy( array , id ) {
    let groups = {}
    array.forEach( function( o ) {
      let group = JSON.stringify( o[id] )
      groups[group] = groups[group] || []
      groups[group].push( o )
    })
    return Object.values(groups)
  }
  const sourceTypeDetailCallbacks = {}
  sourceTypeDetailCallbacks[SOURCE_TYPES.discreteEnvirodata] = (dataSource) => {
    if(dataSource.Data.wqData && dataSource.Data.wqData.WaterQualityDatasets.length > 0) {
      var analytes = dataSource.Data.wqData.WaterQualityDatasets
      var analytesGroups = groupBy(analytes, 'MediaType')

      var html = ''
      analytesGroups.forEach(x => html +=`<div>${x[0].MediaType}: ${x.length} analytes.</div>`)
      return html
    } else {
      return 'No discrete sample data available.'
    }
  }
  sourceTypeDetailCallbacks[SOURCE_TYPES.continuousAquarius] = (dataSource) => {
    if(dataSource.Data.details && dataSource.Data.details.Datasets.length > 0) {      

      var html = ''
      html +=dataSource.Data.details.Datasets.map(x => x.DisplayName).join(',')      
      return html
    } else {
      return 'No continuous data available.'
    }
  }
  sourceTypeDetailCallbacks[SOURCE_TYPES.vegetativeMonitoringEnvirodata] = (dataSource) => {
    if(dataSource.Data.plotData) {    
      var plotData = dataSource.Data.plotData
      var html = `${plotData.PlotType}: ${plotData.Surveys.length} surveys for ${plotData.Specimena.length} specimens`      
      return html
    } else {
      return 'No vegetative data available.'
    }
  }
  sourceTypeDetailCallbacks[SOURCE_TYPES.surveysEnvirodata] = (dataSource) => {
    if(dataSource.Data.SurveyInformations && dataSource.Data.SurveyInformations.length > 0) {    
      var html = ''
      dataSource.Data.SurveyInformations.forEach(x => 
        html += `${x.SurveyType}: ${x.NumberOfSurveys} surveys for ${x.NumberOfSpecimences} specimens`)      
      return html
    } else {
      return 'No survey data available.'
    }
  }

  export default {
    components: {},
    mixins: [MomentUtil, StationUtil],
    props: {
      zoom: {
        type: Number,
        default: 10,
      },
      height: {
        stype: Number,
        default: '600',
      },
      maxHeight: {
        stype: Number,
        default: '850',
      },
      allStations: {
        type: Array,
        default: () => [],
      },
      hideViewDetails: Boolean,
    },
    data() {
      return {
        map: null,
        mapLoaded: false,
        legend: null,
        mapHeight: 600,
        minLat: null,
        minLng: null,
        maxLat: null,
        maxLng: null,
        refreshMapNavChangeTimer: {},
        mapDescriptionLayerText: '',
        mapDescriptionLayer: null,
        // layers: [
        //   {
        //     name: 'topo',
        //     display: 'Topographic',
        //     showOnLoad: true,
        //   },
        //   {
        //     name: 'station',
        //     display: 'Stations',
        //     showOnLoad: true,
        //   },
        //   {
        //     name: 'cad',
        //     display: 'CAD',
        //     showOnLoad: false,
        //   },
        //   {
        //     name: 'sat',
        //     display: 'MR Satellite',
        //     showOnLoad: false,
        //   },
        // ],
      }
    },
    async mounted() {
      if (this.currentUserGroup.name == 'SUNCOR DPL') {
        if (!this.isArcGisTokenValid) {
          await this.acquireAccessToken()
        }

      }
      this.mapHeight = this.height
      if (this.stationWithValidLocation && this.stationWithValidLocation.length) {
        this.drawMap()
      }
    },
    computed: {
      ...app.mapGetters(['navDrawerChange', 'isApplicationLoaded', 'mapServiceConfigs']),
      // TODO // ...stations.mapGetters(['distinctStations']),
      ...sampleActivity.mapGetters(['samples']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...map.mapGetters(['arcGISAccessToken', 'isArcGisTokenValid']),
      layers() {
        var arr = []
        this.mapServiceConfigs.forEach(element => {
          arr.push({
            id: element.Id,
            name: element.LayerName,
            display: element.DisplayName,
            ordinal: element.Ordinal,
            showOnLoad: element.ShowOnLoad,
            mapServices: element.MapServices.map(x => {
              return {
                id: x.Id,
                serviceConfig: x.ServiceConfig,
                serviceType: x.ServiceType,
              }
            }),
          })
        })
        return arr
      },
      stationWithValidLocation() {
        let locations = []
        if (!this.allStations) return locations

        locations = this.allStations.filter(station => {
          return station.Latitude && station.Longitude &&
            !isNaN(station.Latitude) && !isNaN(station.Longitude) &&
            (station.Latitude >= -90 && station.Latitude <= 90 && station.Longitude >= -180 && station.Longitude <=
              180)
        })

        return locations
      },
      centerPoint() {
        let lat = 59.9192
        let lng = -130.358
        let validStations = this.stationWithValidLocation
        if (validStations && validStations.length > 0) {
          lat = 0
          lng = 0
          // Rectangular center point
          let allLat = []
          let allLng = []
          for (var i = 0; i < validStations.length; i++) {
            allLat.push(validStations[i].Latitude)
            allLng.push(validStations[i].Longitude > 0 ? validStations[i].Longitude - 360 : validStations[i]
              .Longitude) //Set on current earth
          }
          allLat.sort((a, b) => {
            return a - b
          })
          this.minLat = allLat[0]
          this.maxLat = allLat[allLat.length - 1]
          lat = (this.maxLat + this.minLat) / 2
          allLng.sort((a, b) => {
            return a - b
          })
          this.minLng = allLng[0]
          this.maxLng = allLng[allLng.length - 1]
          lng = (this.maxLng + this.minLng) / 2
        }

        return {
          'lat': lat,
          'lng': lng,
        }
      },
      hasMRSatellite() {
        const mrRegex = /^.*MR.*$/
        for (let i = 0; i < this.layers.length; i++) {
          const layer = this.layers[i]
          if (mrRegex.test(layer.display)) {
            return true
          }
        }
        return false
      },
    },
    watch: {
      centerPoint() {
        if (this.mapLoaded) {
          this.map.setView([this.centerPoint.lat, this.centerPoint.lng], this.zoom)
        }
      },
      mapHeight() {
        if (this.mapLoaded) {
          document.getElementById('map').style.height = this.mapHeight + 'px'
          this.$nextTick(() => {
            this.reDrawMap()
          })
        }
      },
      navDrawerChange() {
        if (this.mapLoaded) {
          this.navMapRefresh()
        }
      },
      async stationWithValidLocation() {
        if (this.stationWithValidLocation == null || this.stationWithValidLocation.length === 0) {
          if (this.map != null) {
            this.map.off()
            this.map.remove()
            this.map = null
          }
          document.getElementById('mapContainer').innerHTML = ''
          return
        }
        if (this.currentUserGroup.name == 'SUNCOR DPL') {
          if (!this.isArcGisTokenValid) {
            await this.acquireAccessToken()
          }
          this.drawMap()
        }
        if (!this.mapLoaded) {
          this.layersHandler('station', true)
        }
      },
      mapServiceConfigs() {
        if (!this.mapLoaded) {
          return
        }
        this.layers.forEach(layer => {
          if (layer.showOnLoad && layer.name !== 'station') {
            this.layersHandler(layer.name, true, layer.display, layer)
          }
        })
      },
      isApplicationLoaded() {
        if (this.mapLoaded) {
          this.reDrawMap()
        }
      },
      samples() {
        if (this.samples.length > 0 && this.stationName) {
          this.layersHandler('sampleSat', true, 'MR Satellite to MR Sample')
        }
      },
    },
    methods: {
      ...map.mapActions(['acquireAccessToken']),
      ...app.mapActions(['getMapServiceConfig']),
      ...monitoringFeatures.mapActions(['fetchMonitoringFeatureDetails']),
      navMapRefresh() {
        this.refreshMapNavChangeTimer = setInterval(
          () => {
            this.reDrawMap()
          }, 20)
        setTimeout(
          () => {
            clearInterval(this.refreshMapNavChangeTimer)
          }, 300)
      },      
      drawMap() {
        /* eslint-disable */
        if (this.mapLoaded || !this.stationWithValidLocation.length) {
          return
        } else {
          this.mapLoaded = true
        }

        document.getElementById('mapContainer').innerHTML = '<div id=\'map\' style=\'height: ' + this.height + 'px\'></div>'

        let mapOptions = {
          minZoom: 1,
          maxZoom: 19,
          attributionControl: false,
          //Open fullscreen
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: 'topleft'
          }
        }
        this.map = L.map('map', mapOptions)
        //Open the scale
        L.control.scale().addTo(this.map)
        //Sets a map view that contains the given geographical bounds with the maximum zoom level possible
        this.layers.forEach(layer => {
          if (layer.showOnLoad && layer.name !== 'station') {
            this.layersHandler(layer.name, true, layer.display, layer)
          }
        });
        const stationConfig = this.layers.find(x => x.name === 'station')
        this.layersHandler('station', true, stationConfig ? stationConfig.display : undefined)
        this.adjustMapPosition()
        this.reDrawMap()

        this.bindPopupMenuCommandsHandlers(this.map)
        
      },
      adjustMapPosition() {
        if (this.mapLoaded) {
          if (this.currentUserGroup.name == 'MRMe Compensation Lake') {
            this.map.setView([57.264805, -111.462320], 15)
            return
          }
          this.map.setView([this.centerPoint.lat, this.centerPoint.lng], this.zoom)
          if ((this.minLat && this.maxLat) && this.maxLat != this.minLat) {
            this.map.fitBounds([
              [this.minLat, this.minLng],
              [this.maxLat, this.maxLng]
            ])
          }
          this.map.setZoom(this.zoom)
        }
      },
      updateLegend() {
        this.$nextTick(() => {
          if (this.legend != null) {
            this.map.removeControl(this.legend)
          }
          this.legend = L.control({ position: 'topright' })
          this.legend.onAdd = (map) => {
            var div = L.DomUtil.create('div', 'mapLegend')
            var html = this.constructLegendHtml()
            div.innerHTML += html
            return div
          };
          this.legend.addTo(this.map)

          //Hack for IE compatible. 
          //docuemnt.getElementByClassName return a HTML Node collection, which does not support forEach in IE
          var elements = Array.prototype.slice.call(document.getElementsByClassName("commandElement"), 0)
          elements.forEach(x => x.addEventListener('click', this.commandClickHandler, false))
        })
      },
      updateDescription() {
        if (this.mapDescriptionLayer != null) {
          this.map.removeControl(this.mapDescriptionLayer)
        }
        let text = ''

        this.mapDescriptionLayer = L.control({ position: 'bottomleft' })
        this.mapDescriptionLayer.onAdd = (map) => {
          var div = L.DomUtil.create('div', 'mapDescription')

          this.layers.forEach(element => {
            if (element.desc && element.shown) {
              text = text + element.desc + '<br/>'
            }
          });

          div.innerHTML = text
          return div
        };
        let display = false
        this.layers.forEach(element => {
          if (element.desc && element.shown) {
            display = true
          }
        });
        if (display) {
          this.mapDescriptionLayer.addTo(this.map)
        }
      },
      getStationMarkerLayer() {
        let stationMarkers = []

        this.stationWithValidLocation.forEach(element => {
          var marker = new L.Marker([element.Latitude, element.Longitude], {
            icon: new L.DivIcon({
              html: this.constructMarkerHtml(element),
              // iconSize: [30, 42],
            }),
          })
          marker.bindPopup(this.constructPopUpHtml(element))
          stationMarkers.push(marker)
        })

        return L.layerGroup(stationMarkers)

        /* eslint-enable */
      },
      reDrawMap() {
        this.$nextTick(() => {
          if (this.map) {
            this.map.invalidateSize()
          }
        })
      },
      constructMarkerHtml(station) {
        return '<div class="markercontainer">' +
          '<img src="https://unpkg.com/leaflet@1.3.1/dist/images/marker-icon.png">' +
          '<div class="centered">' + station.LocationIdentifier + '</div>' +
          '</div>'
        // return '<div class="markercontainer marker-pin">' +
        // '<div class="centered marker-pin__content">' + station.LocationIdentifier + '</div>' +
      },
      constructPopUpHtml(station) {
        let html = ''

        html += `<h2>${station.LocationIdentifier}</h2>`
        html += `<div>${SOURCE_TYPES_WITH_NAME_INDEX[station.SourceType].dataType}</div>`
        html += `<div>Category: ${station.LocationType}</div>`

        if(station.Latitude && station.Longitude &&
            !isNaN(station.Latitude) && !isNaN(station.Longitude)) {
          html += `<div>GPS: ${station.Latitude.toFixed(3)}, ${station.Longitude.toFixed(3)} <a id="map_zoom_station_${station.Id}" href="javascript:void(0)" class="zoomToCommand">Zoom To</a></div>`
        }

        if (!this.hideViewDetails) {
          html +=
            `</br>
            <div>
              <a href="${ this.$router.resolve({ name: 'monitoringfeature', params: { monitoringFeatureId: station.MonitoringFeatureId } }).href }">
                View Location
              </a>
              <a title="Load Location Detail Information" id="map_detail_station_${station.Id}" href="javascript:void(0)" class="loadDetailCommand">
                &#x21d3;
              </a>
            </div>`
        } else {
          html +=
            `</br>
            <div>
              <a title="Load Location Detail Information" id="map_detail_station_${station.Id}" href="javascript:void(0)" class="loadDetailCommand">
                &#x21d3;
              </a>
            </div>`

        }

        

        return html
      },
      constructLegendHtml() {
        var html = '<h4>Layers</h4><form style="margin: 0px">'

        this.layers.forEach(layer => {
          html = html +
            '<div style="width: 120px"><input class="commandElement" name="command" type="checkbox" value="' + layer
            .name + '" ' + (layer.shown ? 'checked' : '') + '>' + layer.display + '</input></div>'
        })
        if (this.hasMRSatellite) {
          html += '<small style="width: 120px; white-space: nowrap">MR = Most Recent</small>'
        }
        return html + '</form>'
      },
      commandClickHandler(event) {
        var value = event.srcElement.value
        var isChecked = event.srcElement.checked
        var layer = this.layers.find(x => x.name == value)
        this.layersHandler(value, isChecked, layer.display, layer)
      },
      bindPopupMenuCommandsHandlers(map){
        var that = this
        map.on('popupopen', function(e) {
          var marker = e.popup._source
          var elements = Array.prototype.slice.call(document.getElementsByClassName('zoomToCommand'), 0)
          elements.forEach(x => x.addEventListener('click', that.zoomToCommandHandler, false))

          var detailElements = Array.prototype.slice.call(document.getElementsByClassName('loadDetailCommand'), 0)
          detailElements.forEach(x => x.addEventListener('click', (event) => {
            var elementId = event.srcElement.id
            var locationId = elementId.slice('map_detail_station_'.length)        
            var matched = that.stationWithValidLocation.find(x => x.Id == locationId)

            var currentContent = marker._popup.getContent()
            var detailHtml = ''
            if(matched != null && matched.MonitoringFeatureId != null) {
              that.getMonitoringFeatureDetail(matched.MonitoringFeatureId).then(detailHtml => {
                marker._popup.setContent(currentContent + detailHtml)
              })
            } else {
              detailHtml = '<h4>No detail information available for monitoring feature.</h4>'
              
              marker._popup.setContent(currentContent + detailHtml)
            }
          }, false))
        })
      },      
      zoomToCommandHandler(event){
        var elementId = event.srcElement.id
        var locationId = elementId.slice('map_zoom_station_'.length)        
        var matched = this.stationWithValidLocation.find(x => x.Id == locationId)
        this.map.setView([matched.Latitude, matched.Longitude], this.zoom)
      },
      async getMonitoringFeatureDetail(mfId){
        let monitoringFeatureDetails = await this.fetchMonitoringFeatureDetails({
          monitoringFeatureId: mfId,
        })
        if(monitoringFeatureDetails != null && 
          monitoringFeatureDetails.FeatureDataSources &&
          monitoringFeatureDetails.FeatureDataSources.length > 0) {
          var detailHtml = '<h3>Detail Information</h3>'

          monitoringFeatureDetails.FeatureDataSources.forEach(dataSource => {
            var title = SOURCE_TYPES_WITH_NAME.find(x => x.key == dataSource.SourceType).dataType
            var dataHtml = sourceTypeDetailCallbacks[dataSource.SourceType](dataSource)
            detailHtml += `<h4>${title}<h4>`
            detailHtml += `<div class="detailSection">${dataHtml}<div>`
          })

          return detailHtml
        } else {
          return '<h4>No detail information available for monitoring feature.</h4>'
        }
      },

      /* eslint-disable */
      layerSelector(layerList, mapServices, requestDate) {
        mapServices.forEach(element => {
          switch (element.serviceType) {
            case 'basemapLayer':
              layerList.layers.push(L.esri.basemapLayer(JSON.parse(element.serviceConfig).text))
              break

            case 'imageMapLayer':
              layerList.layers.push(L.esri.imageMapLayer(JSON.parse(element.serviceConfig)))
              break

            case 'dynamicMapLayer':
              layerList.layers.push(L.esri.dynamicMapLayer(JSON.parse(element.serviceConfig)))
              break

            case 'wms':
              var config = JSON.parse(element.serviceConfig)
              let wmsConfig = {
                layers: config.layers,
                styles: config.styles,
                format: config.format,
                transparent: config.transparent,
                priority: config.priority,
                maxcc: config.maxcc, // maximum cloud cover            
              }
              if (requestDate) {
                wmsConfig.time = requestDate
              }
              layerList.layers.push(L.tileLayer.wms(config.url, wmsConfig))
              break

            case 'tiledMapLayer':
              var config = JSON.parse(element.serviceConfig)
              layerList.layers.push(L.esri.tiledMapLayer({
                url: config.url,
                token: this.arcGISAccessToken,
              }))
              layerList.layers.forEach(x => {
                x.options.maxZoom = 19
                x.options.maxNativeZoom = 18
                x.options.minNativeZoom = 1
              })
              break
            
            case 'geojson':
              var config = JSON.parse(element.serviceConfig)
              
              const xhr = new XMLHttpRequest()
              xhr.open('GET', config.url, false)
              xhr.send(null)
              const jsonData = JSON.parse(xhr.responseText)
              var geojsonLayer = L.geoJson(jsonData)
              layerList.layers.push(geojsonLayer)

            default:
              break
          }
        })
        return layerList
      },
      layersHandler(name, shouldAdd, display, layerObject) {
        if (!this.stationWithValidLocation.length) {
          return
        }

        let layerData = {
          layers: [],
          desc: ''
        }
        switch (name) {
          case 'topo': {
            layerData = this.layerSelector(layerData, layerObject.mapServices)
            break;
          }

          case 'footprint': {
            layerData = this.layerSelector(layerData, layerObject.mapServices)
            break;
          }

          case 'station': {
            let stationLayer = this.getStationMarkerLayer()
            let stationCount = Object.keys(stationLayer._layers).length
            layerData.desc = stationCount === 1 ? '1 Station' : stationCount + ' Stations'
            layerData.layers.push(stationLayer)
            break;
          }

          case 'sat': {
            var today = new Date()
            var dd = today.getDate()
            var mm = today.getMonth() + 1 //January is 0!
            var yyyy = today.getFullYear()
            var requestDate = yyyy + '-' + mm + '-' + dd

            layerData = this.layerSelector(layerData, layerObject ? layerObject.mapServices : [], requestDate)
            layerData.desc = 'MR Sat: Max Cloud 20%; Request Date ' + requestDate + '; Priority Most Recent'
            break;
          }

          case 'sampleSat': {
            let mostRecentSample = this.samples[0]
            this.samples.forEach(sample => {
              let mostRecentDate = this.convertToJavaScriptDate(mostRecentSample.SampleDate)
              let possibleMostRecentDate = this.convertToJavaScriptDate(sample.SampleDate)
              if (possibleMostRecentDate > mostRecentDate) {
                mostRecentSample = sample
              }
            })
            var requestDate = this.formatDateForSentinel(mostRecentSample.SampleDate)
            layerData = this.layerSelector(layerData, layerObject ? layerObject.mapServices : [], requestDate)
            layerData.desc = 'MR Sat to MR Sample: Max Cloud 20%; Request Date ' + requestDate +
              '; Priority Most Recent'
            break;
          }

          default:
            layerData = this.layerSelector(layerData, layerObject.mapServices)
            break
        }

        let layer = this.layers.find(x => x.name === name)

        if (layer && layer.locations && layer.locations.length) {
          layer.locations.forEach(x => this.map.removeLayer(x))
        }

        if (!layer && !layerData.layers.length) {
          return
        } else {
          if (!layer && layerData.layers.length) {
            //new layer
            layer = {
              name: name,
            }
            this.layers.push(layer)
          }

          if (display) {
            layer.display = display
          }

          if (layerData.desc) {
            layer.desc = layerData.desc
          }

          layer.locations = layerData.layers

          if (!this.mapLoaded) {
            this.drawMap()
          }

          if (shouldAdd) {
            layer.shown = true
            layer.locations.forEach(l => {
              l.addTo(this.map)
            });
          } else {
            layer.shown = false
          }

          this.updateLegend()
          this.updateDescription()
        }
      }
    },

  }
</script>
<style>
  #map {
    z-index: 2
  }

  /* Container holding the image and the text */
  .markercontainer {
    position: relative;
    text-align: center;
  }

  /* Centered text */
  .centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .leaflet-div-icon {
    background: transparent;
    border: none;
  }

  .centered {
    position: absolute;
    top: 15px;
    left: 12px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: white;
    white-space: nowrap;
    padding: 0px;
    margin: 0px;
    height: 20px;
    /* border: 1px solid #2222cc; */
    border-radius: 5px;
    background: #EEE;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
    font-size: 8px;
    color: black;
    min-width: 15px;
  }

  .mapLegend {
    background-color: white;
    height: auto;
    border-radius: 9px;
    padding: 10px;
  }

  .mapDescription {
    font-size: 11px;
    border-radius: 3px;
    padding: 2px;
    background-color: rgba(0, 0, 0, .8);
    color: orangered
  }

  .loadDetailCommand {
    float: right;
  }

  .marker-pin {
    width: 30px;
    height: 30px;
    border-radius: 50% 50% 50% 0;
    background: #c30b82;
    position: absolute;
    transform: rotate(-45deg);
    left: 50%;
    top: 50%;
    margin: -15px 0 0 -15px;
  }

  .marker-pin__content {
    transform: rotate(45deg);
  }
</style>